import React from 'react';

// New — same pattern as ResidentLoginFields. Field names (employeeId,
// mobile) deliberately match backend's
// authenticateStaff(employeeId, mobile, branchId) verbatim — see
// backend/controllers/portal.controller.js.
const StaffLoginFields = ({ formData, handleInputChange }) => (
    <div className="animate-fade-in">
        <div className="form-group">
            <label>Employee ID</label>
            <div className="input-with-icon">
                <i className="fas fa-id-badge"></i>
                <input
                    type="text"
                    name="employeeId"
                    className="input"
                    placeholder="Employee ID"
                    required
                    value={formData.employeeId || ''}
                    onChange={handleInputChange}
                />
            </div>
        </div>
        <div className="form-group">
            <label>Mobile Number</label>
            <div className="input-with-icon">
                <i className="fas fa-mobile-alt"></i>
                <input
                    type="tel"
                    name="mobile"
                    className="input"
                    placeholder="Enter mobile number"
                    required
                    value={formData.mobile || ''}
                    onChange={handleInputChange}
                />
            </div>
        </div>
    </div>
);

export default StaffLoginFields;
